/*import { useQuery } from "@tanstack/react-query";
import { GanttWorkItem } from "../../types/gantt";
import { ProjectAPI } from "../../api/apiClient";

export function useProjectGantt(
  projectId: number,
  asOnDate: string,
  
  
) {
  return useQuery<GanttWorkItem[]>({
    queryKey: ["gantt", projectId, asOnDate],
    queryFn: async () => {
      const res = await fetch(
        `/api/gantt/project/${projectId}?asOnDate=${asOnDate}`
      );

      if (!res.ok) {
        throw new Error("Failed to load Gantt data");
      }

      return res.json(); 
    }
  });
}*/


/*import { useQuery } from "@tanstack/react-query";
import { GanttWorkItem } from "../../types/gantt";
import { ProjectAPI } from "../../api/apiClient";

export function useProjectGantt(
  projectId: number,
  asOnDate: string
) {
  return useQuery<GanttWorkItem[]>({
    queryKey: ["gantt", projectId, asOnDate],
    queryFn: () =>
      ProjectAPI.getGantt(projectId, asOnDate),
  });
}*/
import { useQuery } from "@tanstack/react-query";
import { ProjectAPI } from "../../api/apiClient";
import { GanttWorkItem } from "../../types/gantt";

export function useProjectGantt(
  projectId: number,
  asOnDate: string,
  options?: { enabled?: boolean }
) {
  return useQuery<GanttWorkItem[]>({
    queryKey: ["gantt", projectId, asOnDate],
    queryFn: () => ProjectAPI.getGantt(projectId, asOnDate),
    enabled: options?.enabled, 
  });
} 


